<template>
  <div v-if="!forceCustomerType" class="tla-form-group tla-form-group--margin-medium">
    <label class="tla-form-group__label tla-form-group__label--required" v-html="customerTypeComponent"></label>
    <div v-if="questionLabel">
      <label class="tla-form-group__label"
        v-html="questionLabel"></label>
    </div>
    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in options"
        :key="item.touchpointValue"
        :collectionName="'customerType'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isSelected="item.preSelect"
        :isRadioStyle="true"
        :validationScope="validationScope"
        @customerType="submitCustomerType($event)">
        <div class="generic-touchpoint__text" slot="touchpoint" v-html="item.touchpointName"></div>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('customerType', 'message')">
      Please select an option.
    </span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import GenericTouchPointComponent from '../ui/GenericTouchPointComponent.vue';
import Touchpoint from '../../models/Touchpoint';
import CustomerType from '../../enums/CustomerType';

@Component({
  components: {
  touchpoint: GenericTouchPointComponent
  }
  })
export default class CustomerTypeComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'Is your enquiry on behalf of a business? <span>*</span>' })
  public customerTypeComponent!: string;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: false })
  public forceCustomerType!: boolean;

  @Prop({ default: false })
  public forceBusiness!: boolean;

  @Prop({ default: '' })
  public questionLabel!: string;

  public options: Touchpoint[] = [
    new Touchpoint(`${CustomerType.Business}`, 'Yes'),
    new Touchpoint(`${CustomerType.Personal}`, 'No')
  ];

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }

  public submitCustomerType(value: string) {
    this.$store.dispatch('enquiryModule/submitCustomerType', parseInt(value, 10));
  }

  public created() {
    if (this.forceCustomerType) {
      this.submitCustomerType(`${this.forceBusiness ? CustomerType.Business : CustomerType.Personal}`);
    }
  }
}
</script>
